/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, cx, jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { getFrontendExperiment } from '@atlassian/search-experiment';

import { useAIAnswerContext } from './ai-answer-context';
import { ReadingAidsOptions } from './reading-aids-options';

const styles = cssMap({
	titleWrapper: {
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: token('space.250'),
		marginRight: token('space.300'),
		marginLeft: token('space.300'),
	},
	titleWrapperUpdateStyles: {
		marginTop: token('space.150'),
		marginRight: token('space.200'),
		marginLeft: token('space.200'),
	},
	definitionTitle: {
		font: token('font.heading.small'),
		color: token('color.text'),
	},
});

export const AIAnswerTitle = () => {
	const { commonAttributes, baseQuery } = useAIAnswerContext();
	const { query } = commonAttributes;

	const { serveExperiment: serveDefinitionsUXExp } = getFrontendExperiment({
		abTestId: 'kd_definitions_ux_uplift_exp',
	});
	const serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');

	return (
		<Flex
			xcss={cx(styles.titleWrapper, serveDefinitionUXUpdates && styles.titleWrapperUpdateStyles)}
		>
			<Box xcss={styles.definitionTitle} testId="definition-answer-card-title">
				{baseQuery ? baseQuery : query}
			</Box>
			<ReadingAidsOptions />
		</Flex>
	);
};
